import { ESetCurrentLayoutActionType, TSettingsActions, ESetInitialPageNumberActionType } from '../../actions/settings';
import { ISettings } from '../../types/settings';

export const defaultState: ISettings = {
  currentLayout: 'LayoutNew',
  initialPageNumber: 1,
};

export const settingsReducer = (state = defaultState, action: TSettingsActions) => {
  switch (action.type) {
    case ESetCurrentLayoutActionType.Set:
      return { ...state, currentLayout: action.payload };

    case ESetInitialPageNumberActionType.Set:
      return { ...state, initialPageNumber: action.payload };

    default:
      return state;
  }
};
